class RegionDistanceLayers {
    constructor() {
        this.regionData = new Map();
    }

    calculate(mask, distanceMap) {
        const { width, height } = mask;
        const getAtPos = mask.makeGetterAtPos();

        this.regionData.clear();

        let pos = 0;
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                let id = getAtPos(pos);
                let distance = distanceMap.data[pos];

                let regionData = this.regionData.get(id);
                if (!regionData) {
                    regionData = {
                        layers: [],
                    };
                    this.regionData.set(id, regionData);
                }

                let layerPoints = regionData.layers[distance];
                if (!layerPoints) {
                    layerPoints = new Set();
                    regionData.layers[distance] = layerPoints;
                }

                layerPoints.add(pos);
                pos++;
            }
        }

        for (let [id, regionData] of this.regionData) {
            let count = 0;

            for (let layerPoints of regionData.layers) {
                count += layerPoints.size;
            }

            regionData.count = count;
        }
    }
}

export default RegionDistanceLayers;
